import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AllSavedPrescriptions {
  isLoading: boolean;
  error: boolean;
  message?: string | null;
  AllsavedPrescriptionData?: any;
  Items?: any;
  Pagination?: any;
}

const initialState: AllSavedPrescriptions = {
  isLoading: false,
  error: false,
  message: null,
  AllsavedPrescriptionData: [],
  Items: [],
  Pagination: [],
};

const AllSavedPrescriptionsSlice = createSlice({
  name: "allsavedprescriptions",
  initialState,
  reducers: {
    loadingAllSavedPrescriptions: (
      state: AllSavedPrescriptions,
      action: PayloadAction<{}>
    ) => {
      state.isLoading = true;
    },
    setAllSavedPrescriptions: (
      state: any,
      action: PayloadAction<AllSavedPrescriptions>
    ) => {
      return action.payload;
    },
    clearAllSavePrescData: (
      state: AllSavedPrescriptions,
      action: PayloadAction
    ) => {
      state.error = false;
      state.AllsavedPrescriptionData = [];
      state.Items = [];
      state.Pagination = [];
      state.message = null;
      state.isLoading = false;
    },
  },
});

export const {
  loadingAllSavedPrescriptions,
  setAllSavedPrescriptions,
  clearAllSavePrescData,
} = AllSavedPrescriptionsSlice.actions;

export default AllSavedPrescriptionsSlice.reducer;
